<template>
  <div id="dashboard" class="flex">
    <div id="rooms" class="rooms flex flex-col justify-start">
      <Room
        v-for="(room, i) in rooms"
        :key="`room-${i + 1}`"
        :id="room.uuid"
        :room="room"
        :theme="room.color"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Room from '@/components/modules/Room.vue';
import { defineComponent } from 'vue';
import {mapGetters} from 'vuex';

export default defineComponent({
  name: 'Dashboard',
  components: { Room },
  data() {
    return {
      themes: ['#C9D4E2', '#C9D4E2', '#E9EEF7', '#E9EEF7', '#E3E8FF', '#E3E8FF', '#DCE6F7', '#E3F2FF', '#C9D4E2', '#C9D4E2', '#C9D4E2', '#C9D4E2'],
    };
  },
  computed: {
    ...mapGetters(['rooms']),
    dashboard() {
      return this.$store.state.auth.dashboard;
    },
  },
  mounted() {
    this.scrollRoomsToRight();
  },
  methods: {
    scrollRoomsToRight() {
      requestAnimationFrame(() => {
        const rooms = document.getElementById('rooms');
        if (rooms) {
          rooms.scrollLeft = rooms.scrollWidth;
        }
      });
    },
  },
});
</script>

<style scoped>
#dashboard {
  position: absolute;
  top: 0;
  left: 264px;
  /* Replaces: width: calc(100% - 8px - 244px - 10px); */
  width: calc(100% - 264px);
  min-width: calc(112px * 4);
  /* max-height: calc(100% - 72px); */
  /* overflow-x: scroll; */
  /* overflow-y: scroll; */
  border-right: 2px solid white;
  border-bottom: 2px solid white;
}

#rooms {
  width: 100%;
  min-width: calc(112px * 4);
  overflow-x: scroll;

  @media (max-width: 800px) {
    width: calc(112px * 5);
    min-width: calc(112px * 5);
  }
}

::-webkit-scrollbar {
  width: 17px;
  background-color: transparent;
  display: none;
}
</style>
